module.exports = __webpack_public_path__ + "static/img/card-card-1.76739f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-card-1.jpg
// module id = DgcQ
// module chunks = 1